import { ResponseType } from "../../Types/ServicesType/servicesType";
import { ClinicSettingData, MinistriesType, SettingsDataType } from "./types";
// import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const { SettingsApi } = api;
export const getTableData = async (clinicId?:number): Promise<ResponseType<ClinicSettingData>> => {
  const result = await instance.post(`${SettingsApi.getClinicTabledata}`,{clinicId});
  return result.data;
};
export const getClinicData = async (clinicId?:number): Promise<ResponseType<ClinicSettingData>> => {
  const result = await instance.get(`${SettingsApi.getClinicSetings}/${clinicId}`);
  return result.data;
};

export const updateState = async (params: {
  status: number;
  clinicId: number;
}[]): Promise<ResponseType<string>> => {
    const result =await instance.post(SettingsApi.updateClinicStatus,params)
    return result.data
};

export const getAllMinistries = async (): Promise<ResponseType<MinistriesType[]>>=>{
      const result = await instance.get(SettingsApi.ministriesForClinic)
    return result.data
}

export const saveSettingsData = async ({clinic,logo = null,letterHead = null,letterPad = null}:{clinic:SettingsDataType,logo:File | null,letterHead:File | null,letterPad:File | null}): Promise<ResponseType<string>> => {
       const formData = new FormData()
       formData.append("clinic",JSON.stringify(clinic))
       if(logo)formData.append("logo",logo)
       if(letterHead)formData.append("letterHead",letterHead)
       if(letterPad)formData.append("letterPad",letterPad)
       const result = await instance.post(SettingsApi.saveClinic,formData,{
         "headers":{
            "Content-Type":"multipart/form-data"
         }
      })
      return result.data
};
